import isValidHTML from 'is-html';
import React from 'react';
import { HTML } from "../../../general-widgets/HTML";
import { Paragraph } from "../../../typography/Paragraph";
import { getParagraphsFromStrings } from "../../../../utils/get-paragraphs-from-strings";
import { GridColumn } from "../../../layout/GridColumn";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
export var getLocationDescription = function getLocationDescription(locationDescription) {
  return React.createElement(GridColumn, {
    computer: 6,
    tablet: 12
  }, isValidHTML(locationDescription) ? React.createElement(HTML, {
    htmlString: locationDescription
  }) : getParagraphsFromStrings(locationDescription).map(function (paragraphText, index) {
    return React.createElement(Paragraph, {
      key: buildKeyFromStrings(paragraphText, index)
    }, paragraphText);
  }));
};